import { render } from "./upgrade-button.vue?vue&type=template&id=11954a0d&lang=pug"
import script from "./upgrade-button.vue?vue&type=script&lang=js"
export * from "./upgrade-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__